import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class Point2D extends Primitive {
    x;
    y;
    constructor(x, y) {
        super(Type.Point2D);
        this.x = x;
        this.y = y;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9pbnQyRC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvZ2VvbWV0cnlfMmQvUG9pbnQyRC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBQ3hDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFFOUIsTUFBTSxPQUFPLE9BQVEsU0FBUSxTQUFTO0lBQzNCLENBQUMsQ0FBUTtJQUNULENBQUMsQ0FBUTtJQUVsQixZQUFZLENBQVMsRUFBRSxDQUFTO1FBQzlCLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7UUFDbkIsSUFBSSxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUE7UUFDVixJQUFJLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUNaLENBQUM7Q0FDRiJ9